
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend
} from 'recharts';
import { Employee } from '@/types';

interface StatusData {
  name: string;
  value: number;
  color: string;
}

interface EmployeeStatusCardProps {
  employees?: Employee[];
}

export const EmployeeStatusCard = ({ employees = [] }: EmployeeStatusCardProps) => {
  // Count employees by status
  const activeCount = employees.filter(emp => emp.status === 'active').length;
  const inactiveCount = employees.filter(emp => emp.status === 'inactive').length;
  const onLeaveCount = employees.filter(emp => emp.status === 'on_leave').length;
  
  const data: StatusData[] = [
    { name: 'Active', value: activeCount, color: '#22c55e' },
    { name: 'On Leave', value: onLeaveCount, color: '#f59e0b' },
    { name: 'Inactive', value: inactiveCount, color: '#ef4444' }
  ];

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg font-medium">Employee Status</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={200}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              outerRadius={70}
              fill="#8884d8"
              dataKey="value"
              nameKey="name"
              label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip formatter={(value) => `${value} employees`} />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
